//#region src/updateReloadGuard.ts
var e = "maat.updateReloadedForSha";
function t(t) {
	if (typeof window > "u") return !1;
	try {
		return window.sessionStorage.getItem(e) !== t;
	} catch {
		return !1;
	}
}
function n(t) {
	if (!(typeof window > "u")) try {
		window.sessionStorage.setItem(e, t);
	} catch {}
}
//#endregion
export { n as markAutoReloadedForSha, t as shouldAutoReloadForSha };
